import React from 'react';
import { translate } from 'react-i18next';

import * as Common from 'common/components';
import * as AssetLevel from 'asset_level/components/form';

const AssetLevelFormView = ({
  t,
  asset_level,
  company,
  handleSubmit,
  handleValueChange,
  handleValidation,
  subcompany,
  isFetching,
  isSubmitted,
  handleGroupChange, //Groups
  handleCustomFieldChange, //Groups
  roles,
  groups, //Groups
  isSaving,
}) => (
  <Common.Wrapper fluid={true}>
    {/* <Common.Header title={t("asset_level.title")} /> */}
    <div className="col-12">
      <Common.Portlet
        title={
          t('menu.configuration') +
          ' > ' +
          t('asset_level.title') +
          ' > ' +
          t(asset_level.id ? 'asset_level.edit' : 'asset_level.add')
        }
        icon={'archive'}
      >
        <AssetLevel.Form
          company={company}
          handleSubmit={handleSubmit}
          handleValidation={handleValidation}
          handleValueChange={handleValueChange}
          isSaving={isSaving}
          isSubmitted={isSubmitted}
          subcompany={subcompany}
          roles={roles} //Roles
          handleGroupChange={handleGroupChange} //Groups
          handleCustomFieldChange={handleCustomFieldChange} //Groups
          groups={groups} //Groups
          values={asset_level}
        />
        <Common.LoaderOverlay show={isFetching} />
      </Common.Portlet>
    </div>
  </Common.Wrapper>
);

export default translate()(AssetLevelFormView);



// WEBPACK FOOTER //
// src/modules/secured/modules/asset_level/components/AssetLevelFormView.js